exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loading-spinner[data-v-6d61e302]:before {\n  top: 30px !important;\n  left: 50% !important;\n}\n", ""]);

// exports
